import { IActivationType } from "@/models/IActivationType";

import { BaseRepository } from "@/repositories/BaseRepository";

class ActivationTypeRepository extends BaseRepository<IActivationType> {
    constructor() {
        super("/activationtypes");
    }
}

const activationtypeRepository = new ActivationTypeRepository();

export { ActivationTypeRepository, activationtypeRepository };
